import {
  getEventStudentMessageStatus,
  postEventStudentMessageStatus,
  updateEventStudentMessageStatus,
  deleteEventStudentMessageStatus,
} from "@/services/event-student-message-status.service";

// initial state
const state = () => ({
  eventStudentMessageStatusModel: {},
});

// mutations
const mutations = {
  setEventStudentMessageStatusModel(state, data) {
    state.eventStudentMessageStatusModel = data;
  },
};

// actions
const actions = {
  //Etkinlik Listesi
  async loadEventStudentMessageStatus() {
    return await getEventStudentMessageStatus().then((response) => {
      let data = response.data.data;
      let items = data.items;

      items.map((item, index) => {
        item.index = index + 1;
      });

      return items;
    });
  },

  async postEventStudentMessageStatus(vuexContext, data) {
    return await postEventStudentMessageStatus(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateEventStudentMessageStatus(vuexContext, data) {
    return await updateEventStudentMessageStatus(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteEventStudentMessageStatus(vuexContext, data) {
    return await deleteEventStudentMessageStatus(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addEventStudentMessageStatusModel(vuexContext, data) {
    vuexContext.commit("setEventStudentMessageStatusModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
